export default class BreakpointComparer {
  constructor(breakpoints) {
    this.breakpoints = breakpoints;
  }

  // Determines if the current width has broken through the named breakpoint ie. has it passed the breakpoint.
  // The breakpoint may be a single value or a range of values.
  // If it's a single value, it will return true if the width is greater than or equal to the breakpoint value.
  // When it's a range, it will return true if the width is within the range.
  // in pixels is within a given breakpoint range.

  isWithinBreakpoint(width, breakpointName) {
    const breakpointValue = this.breakpoints[breakpointName];
    if (typeof breakpointValue === "number" || typeof breakpointValue === "string") return width >= convertToPixels(breakpointValue);
    if (Array.isArray(breakpointValue)) {
      const min = convertToPixels(breakpointValue[0]);
      const max = convertToPixels(breakpointValue[1]);
      return width >= min && width <= max;
    }
  }
}

// Convert breakpoint value to pixels
function convertToPixels(breakpointValue) {
  const { value, unit } = parseCssValue(breakpointValue);
  switch (unit) {
    case "px":
      return value;
    case "rem":
      return value * remValueInPixels();
    default:
      throw new Error("[BreakpointComparer] Unsupported unit: " + unit);
  }
}

// Parse CSS value string into numeric value and unit
function parseCssValue(cssValue) {
  if (typeof cssValue === "number") return { value: cssValue, unit: "px" };
  const regex = /^(\d+(?:\.\d+)?)(px|rem)$/i; // As you specified support for px and rem only
  const match = cssValue.match(regex);
  if (match) {
    return { value: parseFloat(match[1]), unit: match[2] };
  } else {
    throw new Error("[BreakpointComparer] Invalid CSS value: " + cssValue);
  }
}

// Get the root element's font-size in pixels (eg. "16px") and return an number (eg. 16).
function remValueInPixels() {
  return parseFloat(window.getComputedStyle(document.documentElement).fontSize);
}
